'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minuteFromNow.js
// module id = 357
// module chunks = 1